<agpr-take-over-panel
    [id]="id"
    [header]="isSocial ? 'Social.postFeed.bulkActions.export.header' : 'Monitoring.postFeed.bulkActions.export.header'"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="closeDialog()"
    [width]="90"
>
    <div
        class="agpr-postExportSetupDialog"
        [agprLoading]="loading"
    >
        <div class="agpr-postExportSetupDialog-panel">
            <label class="agpr-postExportSetupDialog-subtitle">
                {{ (isSocial ? 'Social.postFeed.bulkActions.export.selectExportFields' : 'Monitoring.postFeed.bulkActions.export.selectExportFields') | localize }}
            </label>
            <div class="agpr-postExportSetupDialog-selectAllButton-container">
                <agpr-button
                    class="agpr-postExportSetupDialog-selectAllButton"
                    [style]="buttonTypes.link"
                    ariaLabel="Social.postFeed.bulkActions.export.toggleSelection"
                    (click)="toggleAllFields()"
                >
                    {{ (allFieldsSelected ? 'Social.postFeed.bulkActions.export.selectNone' : 'Social.postFeed.bulkActions.export.selectAll') | localize | uppercase }}
                </agpr-button>
            </div>
            <div
                class="agpr-postExportSetupDialog-comboCheckboxContainer"
                [ngClass]="{'agpr-postExportSetupDialog-comboCheckboxContainer--hasError': !initialEmptyFields && totalSelectedFields.length === 0}"
            >
                <agpr-scroll-panel class="agpr-postExportSetupDialog-comboCheckbox">
                    <ng-container *ngIf="dateData?.fields?.length"><ng-container *ngTemplateOutlet="checkboxCombo; context: { category: dateData }"></ng-container></ng-container>
                    <ng-container *ngTemplateOutlet="checkboxCombo; context: { category: postData }"></ng-container>
                </agpr-scroll-panel>
                <agpr-scroll-panel class="agpr-postExportSetupDialog-comboCheckbox">
                    <ng-container *ngIf="mentionContent?.fields?.length"><ng-container *ngTemplateOutlet="checkboxCombo; context: { category: mentionContent }"></ng-container></ng-container>
                    <ng-container *ngIf="engagementData?.fields?.length"><ng-container *ngTemplateOutlet="checkboxCombo; context: { category: engagementData }"></ng-container></ng-container>
                    <ng-container *ngIf="audienceData?.fields?.length"><ng-container *ngTemplateOutlet="checkboxCombo; context: { category: audienceData }"></ng-container></ng-container>
                    <ng-container *ngTemplateOutlet="checkboxCombo; context: { category: location }"></ng-container>
                    <ng-container *ngIf="organization?.fields?.length"><ng-container *ngTemplateOutlet="checkboxCombo; context: { category: organization }"></ng-container></ng-container>
                </agpr-scroll-panel>
            </div>
            <agpr-form-message *ngIf="!initialEmptyFields && totalSelectedFields.length === 0">
                {{ 'Social.postFeed.bulkActions.export.exportFieldlRequired' | localize }}
            </agpr-form-message>
        </div>

        <div class="agpr-postExportSetupDialog-panel">
            <div class="agpr-postExportSetupDialog-requiredIndicator">
                <span class="agpr-requiredAsterix">*</span>
                <span>{{ 'Social.postFeed.bulkActions.export.requiredIndicator' | localize }}</span>
            </div>
            <agpr-text-input
                [id]="'postExportSetupDialog.fileNameInput'"
                class="agpr-postExportSetupDialog-fileName"
                label="Social.postFeed.bulkActions.export.fileName.label"
                [required]="true"
                placeholder="Social.postFeed.bulkActions.export.fileName.placeholder"
                [(ngModel)]="fileName"
                [maxLength]="255"
            ></agpr-text-input>
            <agpr-form-message
                *ngIf="fileName.length === 0"
                class="agpr-postExportSetupDialog-nameRequiredMessage"
            >
                {{ 'Social.postFeed.bulkActions.export.fileName.errorMessage' | localize }}
            </agpr-form-message>
            <div class="agpr-postExportSetupDialog-formatting">
                <agpr-dropdown
                    [id]="id + '_dateFormat'"
                    label="Social.postFeed.bulkActions.export.dateFormat"
                    [options]="dateFormatOptions"
                    [bindToValue]="true"
                    [(ngModel)]="dateFormat"
                ></agpr-dropdown>
                <div class="agpr-postExportSetupDialog-formatting-time">
                    <label>{{'Social.postFeed.bulkActions.export.timeFormat' | localize}}</label>
                    <agpr-checkbox
                        [id]="'userPreferences_24HourTime'"
                        label="Social.postFeed.bulkActions.export.twentyFour"
                        [(ngModel)]="twentyFourHourTime"
                        [binary]="true"
                    ></agpr-checkbox>
                </div>
            </div>
            <div class="agpr-postExportSetupDialog-receiptContainer">
                <agpr-scroll-panel>
                    <ng-container *ngFor="let category of exportCategories">
                        <div
                            *ngIf="category.selectedFields.length > 0"
                            class="agpr-postExportSetupDialog-receipt"
                        >
                            <label class="agpr-postExportSetupDialog-receiptLabel">{{ category.label | localize }}</label>
                            <agpr-chip-container
                                class="agpr-postExportSetupDialog-receiptChips"
                                [style]="agprComponentStyle.social"
                                [plainMode]="true"
                                [chips]="category.selectedFields"
                                (removeChip)="removeField(category, $event)"
                            ></agpr-chip-container>
                        </div>
                    </ng-container>
                </agpr-scroll-panel>
            </div>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [style]="buttonTypes.primaryB"
            label="Social.postFeed.bulkActions.actionButtonLabel.setAsDefault"
            tooltip="Social.postFeed.bulkActions.actionButtonLabel.setAsDefault.tooltip"
            (click)="setDefaultColumns()"
        ></agpr-button>
        <agpr-button
            [id]="id + '.actionButton'"
            [style]="buttonTypes.primary"
            [disabled]="totalSelectedFields.length === 0 || fileName.length === 0"
            label="Social.postFeed.bulkActions.actionButtonLabel.export"
            (click)="export()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template
    #checkboxCombo
    let-category="category"
>
    <agpr-checkbox
        [id]="category.label + '_selectAllCheckbox'"
        class="agpr-postExportSetupDialog-categoryCheckbox"
        [binary]="true"
        [label]="category.label | localize"
        hiddenLabel="selectAll"
        [(ngModel)]="category.checked"
        (ngModelChange)="categoryToggled(category)"
    ></agpr-checkbox>
    <ul
        class="agpr-postExportSetupDialog-fieldCheckbox"
        [attr.aria-label]="category.label | localize"
    >
        <li *ngFor="let field of category.fields">
            <agpr-checkbox
                [id]="category.label + '_' + field + '_checkbox'"
                [value]="field"
                [label]="field | localize"
                [(ngModel)]="category.selectedFields"
                (ngModelChange)="fieldToggled(category)"
            ></agpr-checkbox>

            <div
                class="agpr-postExportSetupDialog-fieldAutocomplete"
                *ngIf="field === 'Social.postFeed.bulkActions.export.labels.ave'"
            >
                <agpr-autocomplete
                    [id]="category.label + '_' + field + '_autocomplete'"
                    [suggestions]="suggestions$"
                    labelField="label"
                    [ariaLabelledBy]="category.label + '_' + field + '_checkbox_checkboxLabel'"
                    [dropdown]="true"
                    [(ngModel)]="selectedCurrencyOption"
                    [clearOnBlur]="false"
                    [minLength]="1"
                ></agpr-autocomplete>
            </div>
        </li>
    </ul>
</ng-template>
